import { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
// import { UserContext } from "../context/UserContext";

const Users = (props) => {
  // const { user } = useContext(UserContext);
  useEffect(() => {
    // console.log("User at users:", user);
  }, []);
  return (
    <div>
      <p> manager users</p>
    </div>
  );
};
export default Users;
